import { createContext, ReactNode } from 'react';
import useThunkReducer, { ThunkDispatch } from 'react-hook-thunk-reducer';
import uniqueId from 'lodash/uniqueId';

import { TUseToaster, useToaster } from '@r1-frontend/ui-react/experimental/Toaster';

import { initialState, reducer, TAction, TInitialState } from './reducer';

export type TCtxDispatch = ThunkDispatch<TInitialState, TAction>

export type TCtx = {
    state: TInitialState,
    dispatch: TCtxDispatch,
    debugMode?: boolean,
    toaster: TUseToaster,
}

export const Ctx = createContext<TCtx>({
    state: initialState,
    dispatch: () => null,
    debugMode: false,
    toaster: {
        getId: () => uniqueId(),
        add: () => true,
        remove: () => true,
        clear: () => true,
        toasts: [],
    },
});

const Context = ({ children, debugMode = false }: { children: ReactNode, debugMode?: boolean }): JSX.Element => {
    const [state, dispatch] = useThunkReducer<TInitialState, TAction>(reducer, initialState);
    const toaster = useToaster();

    debugMode && console.log(
        state,
    );
    return <Ctx.Provider value={{ state, dispatch, toaster, debugMode }}>
        {children}
    </Ctx.Provider>;
};

export default Context;
